export const navigation = {
  philosophy: "Philosophy",
  services: "Services", 
  training: "Training",
  credentials: "Credentials",
  clientele: "Clientele",
  approach: "Approach",
  contact: "Contact"
};

export const hero = {
  title: "Elite Medical Security",
  subtitle: "For High-Net-Worth Individuals",
  description: "Providing unparalleled emergency medical training and response services to ultra-high-net-worth families, private estates, luxury yachts, and exclusive corporate environments worldwide.",
  cta: "Schedule Consultation"
};

export const philosophy = {
  title: "Our Philosophy",
  subtitle: "Excellence Without Compromise",
  description: "We believe that medical emergencies require immediate, expert intervention. Our philosophy centres on providing the highest calibre of medical training and emergency response services, tailored specifically for discerning clients who demand nothing but the best."
};

export const services = {
  title: "Core Services",
  subtitle: "Comprehensive Medical Solutions",
  cpr_title: "Advanced CPR/AED Training",
  cpr_description: "Professional certification courses designed for household staff, yacht crews, and security personnel.",
  emergency_title: "Emergency Response",  
  emergency_description: "24/7 rapid response medical services with elite paramedic teams.",
  consultation_title: "Medical Consultation",
  consultation_description: "Expert medical advisory services for high-risk environments and activities."
};

export const footer = {
  copyright: "© 2024 U First Doctors. All rights reserved.",
  phone: "Phone",
  email: "Email",
  address: "Address"
};